import { Permission } from "./permission";

export interface IdName {
  id: string;
  name: string;
}

export interface LabelValue {
  label: string;
  value: string | number | null;
  selectedLabel?: string;
  disabled?: boolean;
  tooltip?: string;
}

export interface NameEmail {
  name: string;
  email: string;
}

export type Nullable<T> = T | null | undefined;

export interface NamePath {
  name: string;
  path: string;
}

export interface RolePermissions {
  [key: string]: Permission;
}

export interface ModulePermissions {
  [key: string]: RolePermissions;
}

export interface CompanyInfo {
  name: string;
  address: string;
  phoneNumber: string;
  email: string;
}

// Define the CoordinatorDropdownModel interface
export interface CoordinatorDropdownModel {
  id: string;
  name: string;
  email: string;
}

// Define the AttachmentFileInfoModel interface
export interface AttachmentFileInfoModel {
  fileName: string;
  fileSize: number;
  fileType: string;
}

export interface InsuranceCompanyInfoViewModel {
  info: CompanyInfo;
  primaryContact: CoordinatorDropdownModel;
  logoFileInfo: AttachmentFileInfoModel;
}

export type PagedData<T> = {
  items: T[];
  totalPages: number;
  totalCount: number;
};

export enum CURRENCY {
  USD = "USD",
  GBP = "GBP",
  EUR = "EUR",
  AUD = "AUD",
  CAD = "CAD",
  CHF = "CHF",
}

export type DropdownItem = {
  id: string;
  value: string;
  canBeAddedToProject: boolean;
}

export enum SORT_DIRECTION {
  Ascending = "Ascending",
  Descending = "Descending",
}

export interface PageFilter {
  page: number;
  pageSize: number;
  sortFieldName: string;
  sortDirection: SORT_DIRECTION;
}
